import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const getInviteCode = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/invite_code/getInviteCode?`+params,
        method: 'GET'
    })
}

export const invalidCode = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/invite_code/invalid?`+params,
        method: 'GET'
    })
}